import type { ReactNode } from 'react';
import { ccVar } from '../lib/css';
import { cn } from '../lib/utils';
import { Badge as UIBadge } from './ui/badge';

export interface BadgeProps {
  children: ReactNode;
  /** when set, the badge uses the per-category `--cc` color treatment */
  color?: string;
  className?: string;
}

/** Small pill-style label on shadcn's Badge. With `color`, picks up the `--cc` mechanism. */
export const Badge = ({ children, color, className }: BadgeProps) => {
  // color path uses arbitrary utilities (not the cc-badge component class) so they
  // win over the shadcn base border/text utilities in the cascade.
  const tone = color
    ? 'text-[var(--cc)] border-[color-mix(in_srgb,var(--cc)_34%,var(--line))] bg-[color-mix(in_srgb,var(--cc)_12%,transparent)]'
    : 'border-line text-text-3';
  return (
    <UIBadge
      variant="outline"
      className={cn('mono px-2.5 py-0.5 text-10', tone, className)}
      style={color ? ccVar(color) : undefined}
    >
      {children}
    </UIBadge>
  );
};
